<template>
  <div>
    <div class="dayplanner-suggestions-category-headline">
      <EditableIcon v-model="icon" :is-editable="true"/>
    </div>
    <div class="dayplanner-suggestions-category-headline">
      <inline-editable-text
        @change="onSetCollectionName($event, tscId)"
        :id="tscId"
        :value="name"
        :inline="true"
        :reset-on-update="false"
        :reset-on-cancel="false"
        :lost-focus-is-update="false"
      />
    </div>
    <div v-if="timeslots_checklist && timeslots_checklist.length > 0">
      <!--<pre>{{ timeslots_checklist}}</pre>-->
      <div style="
          display: flex;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: flex-start;
        ">
        <div style="padding-right: 0.5em; font-size: 10pt; line-height: 13pt; ">Smart planning:</div>
        <div>
          <el-checkbox-group v-model="timeslots_selected">
            <div style="display: flex; flex-direction: column; ">
              <div v-for="timeslot in timeslots_checklist" :key="'timeslot - ' + timeslot.key">
                <el-checkbox
                  :label="timeslot.label"
                  :class="{
                    'category-header-checkbox': true,
                    'category-header-checkbox--selected': timeslot.selected
                  }"
                  @change="onToggleSelected(timeslot.originalIdx)"
                />
              </div>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div v-else>Smart timeslots: Add your first slot</div>
  </div>
</template>

<script>
import EditableIcon from "@/components/RoutineCreatorPage/Elements/EditableIcon";

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    magicTimeslots: {
      type: Array
    },
    tscId: {
      type: String
    },
    icon: {
      type: Object
    }
  },
  computed: {
    timeslots_checklist() {
      let timeslots_checklist = [];
      let originalIdx = 0
      this.magicTimeslots.forEach(timeslot => {
        timeslots_checklist.push({
          key: timeslot.timeslotId.toString(),
          label: timeslot.start.format("LT") + " - " + timeslot.end.format("LT"),
          originalIdx: originalIdx++
        });
      });
      return timeslots_checklist;
    },
    timeslots_selected: {
      get() {
        let timeslots_selected = [];
        this.timeslots_checklist.forEach(timeslot => {
          if (!timeslot.disabled) {
            timeslots_selected.push(timeslot.label);
          }
        });
        return timeslots_selected;
      },
      set(timeslots_selected_new, timeslots_selected_old) {
      }
    }
  },
  methods: {
    onToggleSelected(originalIdx) {
      /*console.log(originalIdx, this.magicTimeslots[originalIdx])
      console.log('this.magicTimeslots[originalIdx].enabled before', this.magicTimeslots[originalIdx].enabled)
      this.magicTimeslots[originalIdx].disabled = true
      console.log('this.magicTimeslots[originalIdx].enabled after', this.magicTimeslots[originalIdx].enabled)*/
    },
    onSetCollectionName(newName, timeslot_collection_id) {
      this.$api.timeslot_collection_set_name({
        timeslotCollectionId: timeslot_collection_id,
        name: newName,
      });
    },
  },
  components: {
    EditableIcon
  }
};
</script>
<style>
.dayplanner-suggestions-category-headline {
  font-size: 10pt;
  font-weight: bold;
}
.category-header-checkbox {
  margin: 0;
  padding: 0;
  font-size: 10pt;
  line-height: 12pt;
  color: #444444;
  display: flex;
  align-items: center;
}
.category-header-checkbox--selected {
  margin: 0;
  padding: 0;
  font-size: 10pt;
  line-height: 12pt;
  color: #000000;
  font-weight: bold;
}
</style>
